import { render, staticRenderFns } from "./AdsPublicViewDiscover.vue?vue&type=template&id=38be3bec&scoped=true"
import script from "./AdsPublicViewDiscover.vue?vue&type=script&lang=js"
export * from "./AdsPublicViewDiscover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be3bec",
  null
  
)

export default component.exports